<div class="bg-gray-100 rounded-2xl rounded-tl-md p-5">
    <!-- Header -->
    <spotlight-response-header
        [title]="title"
        [icon]="getIcon()"
        [totalRecords]="data.length"
        [displayedRecords]="paginatedData.length"
        [showCounter]="hasMoreData">
    </spotlight-response-header>

    <!-- Description -->
    <p class="text-[13px] font-inter text-gray-600 leading-relaxed mb-4">
        {{ description }}
    </p>

    <!-- Table Header -->
    <div class="hidden sm:flex items-center px-3 py-2 text-[10px] font-semibold text-gray-500 uppercase tracking-wider border-b border-gray-200">
        <div class="flex-1 min-w-[180px]">NOME</div>
        <ng-container *ngFor="let header of displayHeaders">
            <div [ngClass]="getColumnWidth(header.key)">{{ header.label }}</div>
        </ng-container>
    </div>

    <!-- Table Rows -->
    <div class="divide-y divide-gray-200">
        <div *ngFor="let row of paginatedData; let i = index"
             class="flex flex-col sm:flex-row sm:items-center px-3 py-3 hover:bg-white hover:bg-opacity-50 transition-colors"
             [ngClass]="{'bg-white bg-opacity-20': i % 2 === 0}">

            <!-- Nome com Avatar -->
            <div class="flex items-center gap-3 flex-1 min-w-[180px] mb-2 sm:mb-0">
                <spotlight-avatar
                    [data]="row"
                    size="sm"
                    rounded="full">
                </spotlight-avatar>
                <span class="text-[13px] font-inter font-medium text-gray-800">
                    {{ getMemberName(row) }}
                </span>
            </div>

            <!-- Colunas de dados -->
            <ng-container *ngFor="let header of displayHeaders">
                <!-- Tipo (Badge colorida) -->
                <div *ngIf="getColumnType(header.key) === 'type'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="px-2.5 py-1 rounded-md text-[10px] font-semibold uppercase tracking-wide"
                          [ngClass]="getTypeBadge(row[header.key])">
                        {{ row[header.key] }}
                    </span>
                </div>

                <!-- Valor (com ícone) -->
                <div *ngIf="getColumnType(header.key) === 'value'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <div class="flex items-center gap-1.5">
                        <mat-icon class="icon-size-4 text-gray-400">account_balance</mat-icon>
                        <span class="text-[13px] font-inter font-medium text-gray-800">
                            {{ formatCurrency(row[header.key]) }}
                        </span>
                    </div>
                </div>

                <!-- Transação (Badge) -->
                <div *ngIf="getColumnType(header.key) === 'transaction'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="px-2 py-1 bg-white bg-opacity-60 rounded-md text-[11px] font-inter text-gray-600">
                        {{ row[header.key] }}
                    </span>
                </div>

                <!-- Data -->
                <div *ngIf="getColumnType(header.key) === 'date'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="text-[12px] font-inter text-gray-600">
                        {{ formatDate(row[header.key]) }}
                    </span>
                </div>

                <!-- Idade (badge especial) -->
                <div *ngIf="getColumnType(header.key) === 'age'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="px-2.5 py-1 bg-amber-100 text-amber-700 rounded-full text-[11px] font-semibold font-inter">
                        {{ row[header.key] }} anos
                    </span>
                </div>

                <!-- Texto capitalizado -->
                <div *ngIf="getColumnType(header.key) === 'capitalize'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="text-[12px] font-inter text-gray-700">
                        {{ capitalize(row[header.key]) }}
                    </span>
                </div>

                <!-- Outros campos (texto normal) -->
                <div *ngIf="getColumnType(header.key) === 'default'"
                     [ngClass]="getColumnWidth(header.key)"
                     class="mb-1 sm:mb-0">
                    <span class="sm:hidden text-[10px] text-gray-500 mr-2">{{ header.label }}:</span>
                    <span class="text-[12px] font-inter text-gray-700">
                        {{ formatValue(row[header.key], header.key) }}
                    </span>
                </div>
            </ng-container>
        </div>
    </div>

    <!-- Footer -->
    <spotlight-response-footer
        [executionTimeMs]="executionTimeMs"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        [showPagination]="showPagination"
        (previousPageClick)="onPreviousPage()"
        (nextPageClick)="onNextPage()">
    </spotlight-response-footer>
</div>
